import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Header from '../../../../Components/Header';
import SingleSignOnSideBar from '../../../../Components/SingleSignOnSideBar';
import OverviewTopCard from '../../commonComp/OverviewTopCard';
import ProfileIba from '../../commonComp/profileIba/ProfileIba';
import IBAChart from '../../componentiba/IBAChart';
import '../../Pages/Overview/overview.scss';
import topimg from '../../../../asset/images/ibaimages/topimg.svg';
import calliba from '../../../../asset/images/ibaimages/calliba.svg';
import addiba from '../../../../asset/images/ibaimages/addiba.svg';
import personIba from '../../../../asset/images/ibaimages/personIba.svg';
import rejectiba from '../../../../asset/images/ibaimages/rejectiba.svg';
import axios from 'axios';
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import DurationChangeComponent from '../../../Reports/DurationChangeComponent';
import IBADuration from '../../../IBAAdmin/IBADuration';
import moment from 'moment';
import { toast } from 'react-toastify';
import rupeesIcon from "../../../../asset/images/rupees-iba.svg";
import upArrow from "../../../../asset/images/up-arrow.svg";
import downArrow from "../../../../asset/images/down-arrow-red.svg";
import { HighchartsReact } from 'highcharts-react-official';
import Highcharts from "highcharts";
import moneyIcon from "../../../../asset/images/money-hand-iba.svg";
import CircularKPI from '../../commonComp/CircularKPI/CircularKPI';
import LeaderBoard from '../../commonComp/LeaderBoard/LeaderBoard';
import rupees from "../../../../asset/images/rupees-icon.svg";
import { checkDateRange, compareDate, formatDate } from '../../../../CommonMethhods/CommonMethods';
import FromdateComponent from '../../../Reports/FromdateComponent';
import TodateComponent from '../../../Reports/TodateComponent';
import { axiosInstance0 } from '../../../../CommonMethhods/axiosInstance';


const CARD_CONFIG = [
  {
    key: "opened",
    img: topimg,
    // value: overviewDetails?.accountsOpened || 0,
    leble: "Accounts Opened",
    flag: "opened",
    chartTitle: "Account Opening Overview",
  },
  {
    key: "talktime",
    img: calliba,
    // value: overviewDetails?.totalTalkTime || 0,
    leble: "Total TalkTime",
    flag: "talktime",
    chartTitle: "Total Talktime Overview",
  },
  {
    key: "conversion",
    img: addiba,
    // value: overviewDetails?.conversionRate || 0,
    leble: "Conversion Rate",
    flag: "conversion",
    chartTitle: "Conversion Rate Overview",
  },
  {
    key: "submitted",
    img: personIba,
    // value: overviewDetails?.submitedAccounts || 0,
    leble: "Submitted Accounts",
    flag: "submitted",
    chartTitle: "Submitted Accounts Overview",
  },
  {
    key: "rejected",
    img: rejectiba,
    // value: overviewDetails?.rejectedAccounts || 0,
    leble: "Rejected Accounts",
    flag: "rejected",
    chartTitle: "Rejected Accounts Overview",
  },
];

const OverviewAgentPage = () => {
  const userId = localStorage.getItem("userId")
  const [filterModal, setFilterModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [overviewDetails, setOverviewDetails] = useState({});
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("currentmnth");
  const [errorResp, setErrorResp] = useState("");
  const [graphVal, setGraphVal] = useState([]);
  const [selectedCard, setSelectedCard] = useState(CARD_CONFIG[0]);

  useEffect(() => {
    const date = new Date();
    const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1))
      .format("MM-DD-YYYY");
    const lastDay = moment(date).format("MM-DD-YYYY");

    setFromDate(firstDay);
    setToDate(lastDay);
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!fromDate || !toDate) {
      setErrorResp("Please Select Date");
      return;
    }
  
    const minAllowedDate = moment("01-01-2000", "MM-DD-YYYY");
    const from = moment(fromDate, "MM-DD-YYYY");
    const to = moment(toDate, "MM-DD-YYYY");
  
    if (from.isBefore(minAllowedDate)) {
      setErrorResp("From Date cannot be earlier than 01-01-2000");
      return;
    }
  
    if (to.isBefore(from)) {
      setErrorResp("To Date must be greater than or equal to From Date");
      return;
    }
  
    if (
      compareDate(fromDate) &&
      compareDate(toDate) &&
      checkDateRange(fromDate, toDate)
    ) {
      setErrorResp("");
      getAgentDashboardData();
    } else {
      setErrorResp("Please Select Correct Date");
    }
  };

  useEffect(() => {
    if(selectDuration !== "custom"){
      if (fromDate && toDate) {
        getAgentDashboardData();
      }
  }
  }, [fromDate, toDate, selectDuration]);

  const getAgentDashboardData = async () => {
    const payload = {
      agentId: userId,
      fromDate: fromDate,
      toDate: toDate
    }
    try {
      const response = await axiosInstance0.post(
        IBA_Admin_Section.Agent_Overview_Dashboard,
        payload,
      );
      const data = await response.data;
      if (data.status === 0) {
        setFilterModal(false);
        setOverviewDetails(data.data);
      } else {
        setOverviewDetails({});
      }
    } catch (err) {
      console.log(err);
      setOverviewDetails({});
    }
  };

  const totalRevenue =
    overviewDetails?.agentOverviewDashboardData?.totalRevenue ?? 0;

  const DonutCall = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 135,
      width: 255,
    },
    title: {
      text: `${totalRevenue}%`,
      align: "center",
      verticalAlign: "middle",
      y: 18,
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#1E75D0",
      },
    },
    tooltip: {
      enabled: false,
      // pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        point: {
          events: {
            // click: function () {
            //   handleSectorClick();
            // },
          },
        },
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    // series: [
    //   {
    //     name: "Disposition",
    //     type: "pie",
    //     size: "100%",
    //     innerSize: "75%",
    //     data: [
    //     {
    //       name: "Completed",
    //       y: Number(totalRevenue),
    //     },
    //     {
    //       name: "Remaining",
    //       y: 100 - Number(totalRevenue),
    //     },
    //   ],
    //   },

    // ],

    series: [
      {
        type: "pie",
        size: "100%",
        innerSize: "75%",
        borderWidth: 0,
        data: [
          {
            y: Number(totalRevenue),
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, Highcharts.color("#1C74D0").brighten(0.35).get()],
                [0.4, Highcharts.color("#1C74D0").brighten(0.25).get()],
                [0.7, "#1C74D0"],
                [1, Highcharts.color("#1C74D0").brighten(0.02).get()]
              ]
            }
          },
          {
            y: 100 - Number(totalRevenue),
            color: "#E6EEF8"
          }
        ]
      }
    ]


    // colors: ["#1C74D0", "#1C74D033"],
  };

  const onChangeDuration = (selectedValue) => {

    if (selectedValue === "custom") {
      setErrorResp("")
      setFilterModal(true);
    } else {
      // setRange(selectedValue);
      // overview(selectedValue);
    }

  }

  const progressVal = overviewDetails?.agentOverviewDashboardData?.tier;
  const nextTier =
    progressVal === "L1"
      ? "L2"
      : progressVal === "L2"
        ? "L3"
        : progressVal === "L3"
          ? "L4"
          : progressVal === "L4"
            ? "L4"
            : "L1"

  const revenueVal = overviewDetails?.agentOverviewDashboardData?.totalRevenueVal ?? 0;
  const revenuePer = overviewDetails?.agentOverviewDashboardData?.totalRevenuePer ?? 0;

  const formattedRevenue = Math.abs(revenueVal).toLocaleString();
  const formattedPer = Math.abs(revenuePer).toFixed(2);

  const getInitials = (name) => {
  if (!name) return "NA";

  const words = name.trim().split(" ");
  const initials = words
    .slice(0, 2) // take first two words
    .map(word => word[0]?.toUpperCase())
    .join("");

  return initials;
};

const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp(false);
  };

  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp(false);
  };

   const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <div>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="telecallerDash">
        <div className='card-box iba-page'>
          <div className='wrap-header'>
            <div className='module-title'>Overview</div>
          </div>

          <div className='wrap-header-agent'>
            <div className='overview-agent'>
              <div className='gray-text'>Welcome Back,</div>
              <div className='module-title'>{overviewDetails?.agentName || "-"}</div>
            </div>

            <IBADuration
              setCustomShow={setCustomShow}
              setFromDate={setFromDate}
              setToDate={setToDate}
              onChangeDuration={onChangeDuration}
              setSelectDuration={setSelectDuration}
              selectDuration={selectDuration}
              label={"iba-date"}
            />
          </div>

          <div className="profile-wrap-agent">
            <div className="top-performer-card">
              <div className="card-header-iba">

                <img
                  src={rupeesIcon}
                  alt='rupeesIba'
                  className='rupees-img'
                />

                <div className="card-body">
                  <div>
                    <span className="badge">TOTAL REVENUE EARNED</span>
                    <div className='agent-count'>
                      ₹{overviewDetails?.agentOverviewDashboardData?.totalRevenue || 0}
                    </div>
                  </div>
                  <div className={`diff-value iba-pnl ${revenueVal === 0
                    ? "text-muted"
                    : revenueVal < 0
                      ? "red-txt "
                      : "green-txt"
                    }`}>
                    {revenueVal === 0 ? null : revenueVal < 0 ? (
                      <img src={downArrow} alt="Down Arrow" />
                    ) : (
                      <img src={upArrow} alt="Up Arrow" />
                    )}

                    <span>
                      {formattedRevenue} (
                      <span
                        className={
                          revenuePer === 0
                            ? "text-muted"
                            : revenuePer < 0
                              ? "red-txt"
                              : "green-txt"
                        }
                      >
                        {revenuePer > 0 && "+"}
                        {revenuePer < 0 && "-"}
                        {formattedPer}%
                      </span>
                      )
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="top-performer-card">
              <div className="card-header-iba main-wrapper">
                <div className="chart-donut" style={{ textAlign: "center" }}>
                  <HighchartsReact highcharts={Highcharts} options={DonutCall} />
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>
                    {overviewDetails?.agentOverviewDashboardData?.tier || 0} Progress</div>
                </div>

                <div className="graph-card">

                  <div className='card-body'>
                    <div className="card-title-wrap">
                      <img src={moneyIcon}
                        alt='moneyIcon'
                        className='money-small-icon'
                      />

                      <span className='card-titles'>What you get in {nextTier} ?</span>
                    </div>

                    <div className='wrap-texts'>
                      <span className='label'>Revenue/Min:</span>{" "}
                      <span className='value'>₹{overviewDetails?.agentOverviewDashboardData?.revenuePerMinute || 0}</span>
                    </div>
                    <div className='wrap-texts'>
                      <span className='label'>Revenue/Acc:</span>{" "}
                      <span className='value'>₹{overviewDetails?.agentOverviewDashboardData?.revenuePerAccount || 0}</span>
                    </div>
                    <div className='wrap-texts'>
                      <span className='label'>Bonus:</span>{" "}
                      <span className='value'>₹{overviewDetails?.agentOverviewDashboardData?.bonus || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div style={{ display: "flex", gap: "40px", justifyContent: "space-around", marginBottom: "30px" }}>
            <CircularKPI
              value={overviewDetails?.agentOverviewDashboardData?.totalTalktime}
              total={1500}
              color="#1C74D0"
              label="TOTAL TALKTIME"
              // percentText="▲ 10%"
              percentText={overviewDetails?.agentOverviewDashboardData?.totalTalkTimePer}
              title="Mins"
            />

            <CircularKPI
              value={overviewDetails?.agentOverviewDashboardData?.accountsOpened}
              total={500}
              color="#F4C542"
              label="ACCOUNTS OPENED"
              // percentText="▲ 10%"
              percentText={overviewDetails?.agentOverviewDashboardData?.accountOpendedPer}
            />

            <CircularKPI
              value={overviewDetails?.agentOverviewDashboardData?.accountsSubmitted}
              total={500}
              color="#0DBF8D"
              label="SUBMITTED"
              // percentText="▲ 10%"
              percentText={overviewDetails?.agentOverviewDashboardData?.submittedPer}
            />

            <CircularKPI
              value={overviewDetails?.agentOverviewDashboardData?.accountsRejected}
              total={500}
              color="#ED5727"
              label="REJECTED"
              // percentText="▲ 10%"
              percentText={overviewDetails?.agentOverviewDashboardData?.rejectedPer}
            />
          </div>

          <div className='wrap-cards-leader'>
            <div className='agent-info-card'>
              <div className='wrap-leaderboard'>
                <div className='leader-title'>
                  <span className='main-title'>LEADERBOARD</span>
                  <span className='faded-title'>As per Accounts Opened</span>
                </div>
                <div className='wrap-chart'>
                  <div className='leader-rank-chart'>
                    <LeaderBoard data={overviewDetails?.agentLeaderboardItem} />
                  </div>
                </div>
              </div>
            </div>

            <div className='agent-info-card award-card'>
              <div className='leader-title'>
                <span className='main-title'>BAJAJ AWARD</span>
                <div className='award-card-wrapper'>
                  <span className='broking-title'>BAJAJ BROKING</span>

              <div className='wrap-reward-body'>
                  <div className='wrap-amount'>
                    <div className='icon-wrapper'>
                      <img src={rupees} alt='rupees-icon' />
                    </div>
                    <div className='agent-count'>
                      {overviewDetails?.agentOverviewDashboardData?.valOfRevenueChampionAward || 0}
                    </div>
                  
                  </div>

                  <div className='name-section'>
                    <div className='initial-wrapper'>
                      <span className='name-init'>{getInitials(overviewDetails?.agentOverviewDashboardData?.nameOfRevenueChampionAward)}</span>
                      
                    </div>

                    <span className='show-name'>
                        {overviewDetails?.agentOverviewDashboardData?.nameOfRevenueChampionAward || "-"}
                      </span>
                  </div>

                    </div>
                    

                  <div className='revenue-title-iba'>Revenue<br /> Champion Award</div>

                </div>
              </div>

            </div>
          </div>


        </div>
      </main>

      <Modal
        show={filterModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <form className="profile-modal-content">
            <div className="iput-wrapp">
              <div className="profile-header">Select Custom Date Range</div>

              <div className="profile-form-row">

                <div className="form-group">
                  <FromdateComponent
                    fromDate={handleFromDateChange}
                    formatDate={formatDate(fromDate)}
                    DateReverse={DateReverse}
                  // clientWiseReportForCustomCalanderIcon={true}
                  />
                </div>
                <div className="form-group">
                  <TodateComponent
                    toDate={handleToDateChange}
                    formatToDate={formatDate(toDate)}
                    DateReverse={DateReverse}
                    errorResponse={errorResp}
                  // clientWiseReportForCustomCalanderIcon={true}
                  />
                </div>
              </div>
            </div>

            <div className="profile-footer-iba">
              <Button className="cancel-btn-iba" onClick={() => setFilterModal(false)}>Cancel</Button>
              <Button type="submit" className="save-btn-iba" onClick={handleSubmit}>Apply</Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OverviewAgentPage;
